import { Component } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { NextPage } from '@cvx/nextpage';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { OAService } from '../../../services/oa.service';
import { OaInstalledComponent } from '../oa-installed/oa-installed.component';
import { OaRemovedComponent } from '../oa-removed/oa-removed.component';
import { OaInstalledSaveComponent } from '../oa-installed-save/oa-installed-save.component';
import { OaRemovedSaveComponent } from '../oa-removed-save/oa-removed-save.component';
import { NgIf } from '@angular/common';
@Component({
    selector: 'app-oa-home',
    imports: [DropdownModule, TableModule, ButtonModule, NgIf, NextPage, OaInstalledComponent, OaRemovedComponent, OaInstalledSaveComponent, OaRemovedSaveComponent],
    templateUrl: './oa-home.component.html',
    styleUrl: './oa-home.component.scss'
})
export class OaHomeComponent {
  oAApiData: any;
  oaRemovedData: any;
  isLoading: boolean = false;
  isLoadingOne: boolean = false;
  isLoadingTwo: boolean = false;



  constructor(private oaService: OAService) {
  }

  ngOnInit() {
    this.isLoading = true;
    this.isLoadingTwo = true;
    this.isLoadingOne = true;
    this.setOaData();
    this.setOaRemovedData();
  }

  setOaData() {
    // Remove hardcoded 'ES' to use facilityId from localStorage
    this.oaService.getAllData().subscribe({
      next: (data: any) => {
        if (data) {
          this.oAApiData = data;
        }
      },
      error: (error: any) => {
        console.error('Error fetching OA data:', error);
      },
      complete: () => {
        this.isLoadingOne = false;
      }
    });
  }

  setOaRemovedData() {
    // Remove hardcoded 'ES' to use facilityId from localStorage
    this.oaService.getRightData().subscribe({
      next: (data: any) => {
        if (data) {
          this.oaRemovedData = data;
        }
      },
      error: (error: any) => {
        console.error('Error fetching OA data:', error);
      },
      complete: () => {
        this.isLoadingTwo = false;
      }
    });
  }
}
